import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ItAssetDocumentsQuery } from 'generated/resources/graphql'
import {
  DeleteItAssetDocumentDocument,
  ItAssetDocumentsDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type DocumentNode = NonNullable<
  NonNullable<
    ItAssetDocumentsQuery['itManagement']['itAssetDocumentsConnection']
  >['edges'][number]['node']
>

interface Props {
  document: DocumentNode
  assetId: string
  onClose: () => void
}

export const DeleteItAssetDocumentModal = ({ document, assetId, onClose }: Props) => {
  const [deleteItAssetDocument, { loading: deleteLoading }] = useMutation(
    DeleteItAssetDocumentDocument,
    {
      extractorFn: (data) => data.itManagementMutations.deleteItmanagementItAssetDocument,
    }
  )

  const handleDeleteDocument = async () => {
    try {
      const result = await deleteItAssetDocument({
        variables: { id: document.id },
        refetchQueries: [
          {
            query: ItAssetDocumentsDocument,
            variables: { itAssetId: assetId },
          },
        ],
      })

      const handled = handleResult(result, () => undefined)
      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('it_management.asset_details.documents.delete_success'),
        })
        onClose()
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('it_management.asset_details.documents.delete_error'),
        })
      }
    } catch (error) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('it_management.asset_details.documents.delete_error'),
      })
    }
  }

  const documentName =
    document.documentFilename || i18n.t('it_management.asset_details.documents.draft')

  return (
    <Modal
      title={i18n.t('it_management.asset_details.documents.delete_modal.title')}
      onClose={onClose}
      illustration={'delete-cross'}
      description={i18n.t('it_management.asset_details.documents.delete_modal.description', {
        filename: documentName,
      })}
      onSubmit={handleDeleteDocument}
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <F0Button
            variant="outline"
            onClick={onClose}
            disabled={deleteLoading}
            label={i18n.t('common.cancel')}
          />
          <F0Button
            type="negative"
            submit
            loading={deleteLoading}
            label={i18n.t('common.destroy')}
          />
        </Box>
      }
    />
  )
}
